import * as React from 'react'
import Slider from 'react-slick'
import Link from 'next/link'

import {logEvent} from '@lib/gtm'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

export const Demos = () => {
  const data = [
    {
      name: 'OCR',
      href: '/demo/ocr',
      img: ['/images/ai/demos/ocr.jpg', '/images/ai/demos/ocr@2x.jpg'],
    },
    {
      name: 'Demographic',
      href: '/demo/demographic',
      img: [
        '/images/ai/demos/demographic.jpg',
        '/images/ai/demos/demographic@2x.jpg',
      ],
    },
    {
      name: 'Object Detection and Image Classifier API',
      href: '/demo/detection',
      img: [
        '/images/ai/demos/object-detection.jpg',
        '/images/ai/demos/object-detection@2x.jpg',
      ],
    },
  ]

  const settings = {
    className: 'center',
    centerMode: true,
    infinite: true,
    dot: false,
    speed: 400,
    centerPadding: '60px',
    slidesToShow: 3,
    swipeToSlide: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 580,
        settings: {
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          nextArrow: <NextArrow />,
          prevArrow: <PrevArrow />,
        },
      },
    ],
  }

  return (
    <div className='AI__demos'>
      <header className='AI__demos__header'>
        <div className='container'>
          <h2>ทดลองใช้งาน AI</h2>
          <p>
            บริการ AI ด้านอื่นๆของเราที่อยากให้คุณได้ทำความรู้จัก
            สามารถไปทดสอบได้ที่ลิงค์ด้านล่าง
          </p>
        </div>
      </header>

      <div className='AI__demos__container'>
        <Slider {...settings}>
          {data.map((item, index) => {
            return (
              <div key={index}>
                <a
                  href={item.href}
                  title={item.name}
                  rel='noopener noreferrer'
                  target='_blank'
                  className='AI__demos__item'
                >
                  <img
                    src={item.img[0]}
                    srcSet={item.img[1]}
                    alt={item.name}
                    loading='lazy'
                  />
                  <span>{item.name}</span>
                </a>
              </div>
            )
          })}
        </Slider>

        <Link href='/demo'>
          <a
            className='AI__demos__button'
            title='More Demo'
            onClick={() => {
              logEvent({
                ga: {
                  category: 'AI Consultation',
                  action: 'Click More Demo',
                },
              })
            }}
          >
            <span>More Demo</span>
          </a>
        </Link>
      </div>
    </div>
  )
}

type SlideNavProps = {
  onClick?: () => void
}

const NextArrow = ({onClick}: SlideNavProps) => {
  return (
    <div
      className='AI__demos__arrow AI__demos__arrow--next'
      onClick={onClick}
    />
  )
}

const PrevArrow = ({onClick}: SlideNavProps) => {
  return (
    <div
      className='AI__demos__arrow AI__demos__arrow--prev'
      onClick={onClick}
    />
  )
}
